import axios from 'axios'

let baseURL
const prodBaseUrl = window.location.protocol + '//' + window.location.hostname + (window.location.port ? ':' + window.location.port : '')

// eslint-disable-next-line no-undef
if (process.env.NODE_ENV === 'development') {
  baseURL = 'http://localhost/apiv2'
} else {
  baseURL = prodBaseUrl + '/apiv2'
}

const instance = axios.create({ baseURL })
export default instance
// add auth token via
//instance.defaults.headers.common['Authorization'] = AUTH_TOKEN;
